// Novidades do sistema (popup ao entrar + página /novidades).
//
// COMO ACRESCENTAR: no mesmo PR da mudança, coloque um item NO TOPO desta lista.
// - id: "AAAA-MM-DD-nome-curto" (data de implantação + nome em minúsculas, sem acento).
//   A ordem dos ids é a ordem de "mais nova"; o servidor guarda até qual id cada pessoa leu.
// - Escreva para quem usa o sistema, não para quem programa: o que mudou, por que ajuda,
//   como usar e onde encontrar. Nada de nome de rota, tabela ou commit.
// - permissoes (opcional): só mostra para quem tem pelo menos uma dessas permissões.
const NOVIDADES = [
  {
    id: '2026-11-02-lembretes-status',
    data: '2026-11-02',
    titulo: 'Editar Lembretes: agora dá para marcar "Pronto para uso"',
    resumo: 'O status de cada mensagem automática passou a poder ser mudado direto na tela, sem pedir ajuda à TI.',
    comoUsar: [
      'Todo cadastro novo começa como "Em aprovação (Meta)".',
      'Depois que a Meta aprovar o template, clique em "Editar", escolha "Pronto para uso" no campo Status e salve.',
      'Só cadastros "Pronto para uso" e ativos (botão ON) são usados para enviar mensagens. Para pausar um envio, clique em OFF.',
    ],
    ondeEncontrar: { texto: 'Configurações > Editar Lembretes', link: '/atendimentos-presenciais/lembretes-configuracoes' },
    permissoes: ['configuracoes.lembretesTipos'],
  },
  {
    id: '2026-11-02-novidades',
    data: '2026-11-02',
    titulo: 'Novidades do sistema: acompanhe o que mudou',
    resumo: 'Sempre que o sistema ganhar algo novo, você vai ver um aviso ao entrar, com a explicação de como usar.',
    comoUsar: [
      'Em cada novidade do aviso, clique em "Marcar como lida". "Já li todas" marca todas de uma vez.',
      '"Ver depois" fecha o aviso agora; ele volta no próximo acesso com o que você ainda não leu.',
      'Na página "Novidades do sistema" está a lista completa, com a data de cada mudança. Dá para marcar uma como não lida para reler depois.',
      'Tem uma sugestão? Use o botão "Abrir chamado de TI" no topo da página de novidades.',
    ],
    ondeEncontrar: { texto: 'Ícone de jornal na barra do topo, ou menu Suporte > Novidades do sistema', link: '/novidades' },
  },
  {
    id: '2026-11-02-sala-de-espera',
    data: '2026-11-02',
    titulo: 'Sala de espera: chame o próximo cliente sem confusão',
    resumo: 'A recepção agora vê quem chegou, há quanto tempo espera e quem já está sendo atendido por outra colega.',
    comoUsar: [
      'Quando o cliente chega, a recepção muda a situação dele para AGUARDANDO na ficha, como já é feito. Ele entra na fila da sala de espera.',
      'Clique em "Chamar" para atender o próximo da fila. O nome dele passa para "Em atendimento" com o seu nome, e as colegas veem isso na hora.',
      'Chamou por engano ou o cliente não estava? Use "Devolver à fila": ele volta para a mesma posição.',
      'Uma colega precisou sair no meio do atendimento? Use "Assumir" para continuar de onde ela parou.',
      'Duas pessoas não conseguem chamar o mesmo cliente: quem clicar depois recebe um aviso dizendo com quem ele está.',
    ],
    ondeEncontrar: { texto: 'Meu dia, bloco "Sala de espera"', link: '/meu-dia' },
    permissoes: ['menu.atendimentos', 'pessoa.aba.agendamento'],
  },
  {
    id: '2026-11-02-meu-dia',
    data: '2026-11-02',
    titulo: '"Meu dia" é a nova página inicial',
    resumo: 'Ao entrar no sistema, você vê numa tela só o que precisa da sua atenção hoje, na sua unidade.',
    comoUsar: [
      'A tela mostra a sala de espera, as tarefas de contato pendentes e as perícias e avaliações da semana. Cada parte aparece só para quem tem acesso a ela.',
      'No topo dá para trocar o dia (por exemplo, para preparar o dia de amanhã) e a unidade.',
      'No fim da tela há o quadro "Como usar esta tela", com tudo explicado passo a passo.',
    ],
    ondeEncontrar: { texto: 'Primeiro item do menu: "Meu dia"', link: '/meu-dia' },
  },
  {
    id: '2026-11-01-whatsapp-oficial',
    data: '2026-11-01',
    titulo: 'Mensagem oficial de WhatsApp direto do Cadastro Geral',
    resumo: 'O botão verde de WhatsApp de cada cliente agora envia a mensagem oficial da empresa, já com o nome do cliente.',
    comoUsar: [
      'Clique no botão verde de WhatsApp na linha do cliente.',
      'Escolha o telefone, confira o nome que vai na mensagem e veja a prévia do texto.',
      'Clique em "Enviar mensagem". O envio fica registrado nas Etapas do cliente.',
      'Os links antigos de WhatsApp Web continuam no mesmo quadro, logo abaixo.',
    ],
    ondeEncontrar: { texto: 'Cadastro Geral, botão verde em cada cliente', link: '/pessoas' },
    permissoes: ['pessoa.whatsapp.template'],
  },
  {
    id: '2026-11-01-cadastro-geral',
    data: '2026-11-01',
    titulo: 'Cadastro Geral mais limpo e fácil de ler',
    resumo: 'A lista de clientes ficou mais organizada: menos texto repetido, nomes inteiros e filtros mais claros.',
    comoUsar: [
      'Campos vazios aparecem como um traço "—", e não mais como "Não Definido" em toda linha.',
      'A busca continua igual: digite o texto e depois escolha em "Buscar por" (nome, CPF, telefone...).',
      'Os filtros aplicados aparecem logo abaixo da busca, e o "×" de cada um remove só aquele filtro.',
      'Os botões de cada cliente viraram ícones: abrir a ficha, excluir e WhatsApp. Passe o mouse para ver o nome de cada um.',
    ],
    ondeEncontrar: { texto: 'Menu "Cadastro Geral"', link: '/pessoas' },
    permissoes: ['menu.pessoas'],
  },
  {
    id: '2026-11-01-menu-organizado',
    data: '2026-11-01',
    titulo: 'Menu lateral organizado por assunto',
    resumo: 'Os itens do menu agora ficam em grupos: o dia a dia no topo, depois Relatórios, Gestão e Suporte.',
    comoUsar: [
      'Os itens são os mesmos de antes, só mudaram de lugar. Cada grupo só aparece se você tiver algum item dele.',
    ],
    ondeEncontrar: { texto: 'Menu lateral, à esquerda' },
  },
  {
    id: '2026-11-01-acessos',
    data: '2026-11-01',
    titulo: 'Acessos mais seguros por setor',
    resumo: 'Cada tela e cada ação do sistema agora confere se o seu setor tem permissão para ela.',
    comoUsar: [
      'Se aparecer "Acesso não autorizado", a mensagem diz qual permissão falta.',
      'Nesse caso, peça a um supervisor para liberar a permissão para o seu setor em Configurações > Permissões.',
    ],
  },
];

export default NOVIDADES;
